import React, { useContext } from 'react';
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Typography,
  message
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { useMutation } from '@tanstack/react-query';
import axios from '../../config/axios';
// import loginLogo from '../../assets/loginbg.jpg'


function Login() {
  const [messageApi, contextHolder] = message.useMessage();
  const redirect = useNavigate();
  const { dispatch } = useContext(AuthContext);
  console.log();
  const { mutate, isLoading } = useMutation({
    mutationFn: data => {
      axios
        .post('/auth/login', data)
        .then(res => {
          dispatch({ type: "LOGIN", payload: JSON.stringify(res.data) });
          messageApi.open({
            type: 'success',
            content: 'บันทึกข้อมูลสำเร็จ',
            duration: 1,
            onClose: () => redirect('/')
          });

        })
        .catch(err => {
          console.log(err)
          messageApi.open({
            type: 'error',
            content: 'บัญชีผู้ใช้ หรือ รหัสผ่านไม่ถูกต้อง',
          });
        })
    },
  });

  const onFinish = (values) => mutate(values);

  return (
    <div className='login-background'>
      {contextHolder}
      {/* <div className='login-box'> */}
      <Row justify='center' style={{ width: '100%' }}>
        <Col xs={24} sm={12} lg={8} xl={6} className='login-box'>
          <Typography.Title
            level={3}
            style={{ textAlign: 'center' }}
          >เข้าสู่ระบบ</Typography.Title>
          <Form
            name="register"
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="บัญชีผู้ใช้"
              name="username"
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="รหัสผ่าน"
              name="password"
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล',
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                disabled={isLoading}
                style={{
                  width: '100%'
                }}
              >
                เข้าสู่ระบบ
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      {/* </div> */}
    </div>
  )
}

export default Login